import webApiUtil from '@/common/webApiUtil'
import apiUrl from '@/common/apiUrl'
import * as _ from 'lodash'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getLocationAndZoneTypeList: async ({rootState}) => {
      rootState.isLoading = true
      const params = {
        page_latest_id: 0,
        page_size: 0
      }
      const res = await Promise.all([
        webApiUtil.post(apiUrl.provinceList, _.merge(params, {page_size: 1000})),
        webApiUtil.post(apiUrl.districtList, _.merge(params, {page_size: 2000})),
        webApiUtil.post(apiUrl.communeList, _.merge(params, {page_size: 50000})),
        webApiUtil.post(apiUrl.zoneTypeList, _.merge(params, {page_size: 2000}))
      ])
      rootState.isLoading = false

      if (res && res.length) {
        res[0].data['status'] === 0 && localStorage.setItem('provinceList', JSON.stringify(res[0].data['provinces']))
        res[1].data['status'] === 0 && localStorage.setItem('districtList', JSON.stringify(res[1].data['districts']))
        res[2].data['status'] === 0 && localStorage.setItem('communeList', JSON.stringify(res[2].data['communes']))
        res[3].data['status'] === 0 && localStorage.setItem('zoneTypeList', JSON.stringify(res[3].data['zoning_types']))
      }
    },
    uploadFileToServer: async ({rootState}, _file) => {
      try {
        rootState.isLoading = true
        const res = await webApiUtil.upload(_file)

        if (res && res.data && res.data.status === 0 && res.data.message !== 'No Data') {
          return res.data.imageurl
        } else {
          return null
        }
      } catch (e) {
        return null
      } finally {
        rootState.isLoading = false
      }
    }
  }
}
